import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3b33e9b6&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=3b33e9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33e9b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b33e9b6')) {
      api.createRecord('3b33e9b6', component.options)
    } else {
      api.reload('3b33e9b6', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3b33e9b6&scoped=true&", function () {
      api.rerender('3b33e9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PrimaryCustomField/main.vue"
export default component.exports